export const openPopup = (url, width = 1300, height = 800) => {
    const left = (window.screen.width / 2) - (width / 2);
    const top = (window.screen.height / 2) - (height / 2);
    window.open(url, 'popup', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`);
}
